import {Token, Ether} from '@uniswap/sdk-core'
import {OVL_TOKEN_ADDRESS, LL_TOKEN_ADDRESS} from './addresses'
import {SupportedChainId} from './chains'
import ETHEREUM_LOGO from '../assets/images/ethereum-logo.png'
import ARBITRUM_LOGO from '../assets/images/arbitrum-logo.png'
import ARBITRUM_TESTNET_LOGO from '../assets/images/arbitrum-testnet-logo.png'
import IMOLA_LOGO from '../assets/images/imola-logo.png'
import BARTIO_LOGO from '../assets/images/berachain-logo.png'
import {BigNumber} from 'ethers'

export const ONE_BN = BigNumber.from(10).pow(18)

export const OVL: {[chainId: number]: Token} = {
  [SupportedChainId.MAINNET]: new Token(SupportedChainId.MAINNET, OVL_TOKEN_ADDRESS[1], 18, 'OVL', 'Overlay'),
  [SupportedChainId.GÖRLI]: new Token(SupportedChainId.GÖRLI, OVL_TOKEN_ADDRESS[5], 18, 'OVL', 'Overlay'),
  [SupportedChainId.RINKEBY]: new Token(SupportedChainId.RINKEBY, OVL_TOKEN_ADDRESS[4], 18, 'OVL', 'Overlay'),
  [SupportedChainId.ARBITRUM]: new Token(SupportedChainId.ARBITRUM, OVL_TOKEN_ADDRESS[42161], 18, 'OVL', 'Overlay'),
  [SupportedChainId.ARBITRUM_GÖRLI]: new Token(SupportedChainId.ARBITRUM_GÖRLI, OVL_TOKEN_ADDRESS[421613], 18, 'OVL', 'Overlay'),
  [SupportedChainId.ARBITRUM_SEPOLIA]: new Token(SupportedChainId.ARBITRUM_SEPOLIA, OVL_TOKEN_ADDRESS[421614], 18, 'OVL', 'Overlay'),
  [SupportedChainId.IMOLA]: new Token(SupportedChainId.IMOLA, OVL_TOKEN_ADDRESS[SupportedChainId.IMOLA], 18, 'OVL', 'Overlay'),
  [SupportedChainId.BARTIO]: new Token(SupportedChainId.BARTIO, OVL_TOKEN_ADDRESS[80084], 18, 'OVL', 'Overlay'),
}

export const NETWORK_LOGO: {[chainId: number]: string} = {
  [SupportedChainId.MAINNET]: ETHEREUM_LOGO,
  [SupportedChainId.ARBITRUM]: ARBITRUM_LOGO,
  [SupportedChainId.GÖRLI]: ETHEREUM_LOGO,
  [SupportedChainId.ARBITRUM_GÖRLI]: ARBITRUM_LOGO,
  [SupportedChainId.ARBITRUM_SEPOLIA]: ARBITRUM_TESTNET_LOGO,
  [SupportedChainId.IMOLA]: IMOLA_LOGO,
  [SupportedChainId.BARTIO]: BARTIO_LOGO,
}

//@dev: remove LL Token addresses after bridge testing
export const LL: {[chainId: number]: Token} = {
  [SupportedChainId.MAINNET]: new Token(SupportedChainId.MAINNET, LL_TOKEN_ADDRESS[1], 18, 'LL', 'lay'),
  [SupportedChainId.ARBITRUM]: new Token(SupportedChainId.ARBITRUM, LL_TOKEN_ADDRESS[42161], 18, 'LL', 'lay'),
}

export class ExtendedEther extends Ether {
  // public get wrapped(): Token {
  //   if (this.chainId in WETH9_EXTENDED) return WETH9_EXTENDED[this.chainId]
  //   throw new Error('Unsupported chain ID')
  // }

  private static _cachedEther: {[chainId: number]: ExtendedEther} = {}

  public static onChain(chainId: number): ExtendedEther {
    return this._cachedEther[chainId] ?? (this._cachedEther[chainId] = new ExtendedEther(chainId))
  }
}
